import _ from 'lodash'
import { BindAll } from 'lodash-decorators'
import moment from 'moment'

import { action, observable, computed } from 'mobx'

import { VendorUserRoles, VendorUserTiers } from 'common/server/server_types'

import {
  index as indexUsers,
  invite_user,
  ManagedVendorUser,
  update_user,
  UpdateRequest,
} from 'vendor/server/vendor_settings/manage_users'
import { update_vendor, UpdateVendorRequest } from 'vendor/server/vendor_settings/vendor'

// ID implies it is one of our default columns, and you can't change
// Name of our default columns

@BindAll()
export default class VendorSettingStore {
  // *************************************** USERS ***************************************
  users = observable.array<ManagedVendorUser>([])

  @action
  maybeIndexUsers() {
    if (!this.users.length) {
      return this.indexUsers()
    }
  }

  @action
  async indexUsers() {
    const { data } = await indexUsers()
    this.users.replace(data?.vendor_users)
  }

  @computed get actualNumPremiumUsers(): number {
    return _.filter(this.users, (u) => u.tier == VendorUserTiers.PREMIUM).length
  }

  filterUsers(ids: string[]): ManagedVendorUser[] {
    return _.filter(this.users, (user) => ids.includes(user.id))
  }

  async updateUser(id: string, params: UpdateRequest): Promise<void> {
    await update_user(id, params)
    const users = [...this.users]
    const index = _.findIndex(this.users, { id })

    const { role, is_public, is_active } = params

    if (role) users[index].role = role

    if (is_public !== undefined) users[index].is_public = is_public

    if (![null, undefined].includes(is_active)) {
      users[index].is_active = is_active
      users[index].deactivated_at = new Date().toISOString()
    }

    // For some reason the full replace is triggering a re-render but not the individual replace. It's as if
    // The observable isn't deep although Mobx documentation says it should be. Could also be an issue
    // with the Table component
    this.users.replace(users)
  }

  async resendInvitation(id: string): Promise<void> {
    const updated_user = await update_user(id, { resend_invitation: true })
    const users = [...this.users]
    const index = _.findIndex(this.users, { id })
    users[index].invitation_sent_at = moment().toISOString()
    users[index].invitation_link = updated_user.data.invitation_link
    users[index].invitation_expires_at = updated_user.data.invitation_expires_at

    // For some reason the full replace is triggering a re-render but not the individual replace. It's as if
    // The observable isn't deep although Mobx documentation says it should be. Could also be an issue
    // with the Table component
    this.users.replace(users)
  }

  async inviteUsers(emails: string, role: VendorUserRoles): Promise<void> {
    // HACK: Want to catch errors so await invitations serially
    for (const email of emails.split(',')) {
      await invite_user({ email: email.trim(), role })
    }
  }

  async updateCurrentVendor(params: UpdateVendorRequest) {
    const { data } = await update_vendor(params)
    return data
  }
}
